$('#how__slider').slick({
    mobileFirst: true,
    variableWidth: false,
    slidesToShow: 1,
    dots: false,
    arrows: false,
    speed: 300,
    centerMode: true,
    slidesToShow: 1,
    initialSlide: 0,
    infinite: false,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                centerMode: false
            }
        },
        {
            breakpoint: 1023,
            settings: {
                slidesToShow: 3,
                centerMode: false
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                dots: false
            }
        }
    ]
});

$('.how__slider_slide').on('click', function () {
    let content = $('.how__slider_content'),
        btn = $('.how__more_btn'),
        openText = btn.attr('data-open'),
        closeText = btn.attr('data-close');
    
    if(!content.hasClass('how__slider_content--open')){
        content.addClass('how__slider_content--open');
        btn.html(closeText);
    }else{
        content.removeClass('how__slider_content--open');
        btn.html(openText);

    }
})